<!--
 * @Author: wufei
 * @Date: 2020-08-12 14:43:25
 * @LastEditTime: 2020-09-18 17:45:53
 * @Description:
 * @FilePath: \mobile-revive\src\views\index\table.vue
-->
<template>
  <div class="revive-table">
    <div class="search-bar">
      <div class="btns">
        <div class="my-button" :class="{active:isObtains}" @click="switchActive('isObtains')">我司获取</div>
        <div class="my-button" :class="{active:isFocus}" @click="switchActive('isFocus')">重点跟进</div>
        <div class="my-button" :class="{active:isRegret}" @click="switchActive('isRegret')">遗憾项目</div>
      </div>

      <div class="right">
        <span class="divide">|</span>
        <div class="my-button round " @click="searchState = !searchState"><icon name="search" /></div>
      </div>

    </div>

    <search v-show="searchState" v-model="keyword" @search="confirmSearch" />

    <table class="my-table" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th width="25%">项目名称</th>
          <th width="25%" @click="sort('devMonthFlow')">流量偏差 <i class="sort" :class="{'sort-down':orderByColumn === 'devMonthFlow' && orderByType === 'DESC','sort-up':orderByColumn === 'devMonthFlow' && orderByType === 'ASC'}" /></th>
          <th width="25%" @click="sort('devAvgPrice')">价格偏差 <i class="sort" :class="{'sort-down':orderByColumn === 'devAvgPrice' && orderByType === 'DESC','sort-up':orderByColumn === 'devAvgPrice' && orderByType === 'ASC'}" /></th>
          <th width="25%" @click="sort('evalType')">预判精准度 <i class="sort" :class="{'sort-down':orderByColumn === 'evalType' && orderByType === 'DESC','sort-up':orderByColumn === 'evalType' && orderByType === 'ASC'}" /></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.landId" @click="goDetail(item)">
          <td width="25%" :class="{show:item.show,name:!item.show}">{{ item.landName }}</td>
          <td width="25%">{{ item.devMonthFlow | keepInteger(1) | unitFormat('%') }}</td>
          <td width="25%">{{ item.devAvgPrice | keepInteger(1) | unitFormat('%') }}</td>
          <td width="25%">{{ item.evalTypeName }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Icon, Picker, Toast, Search } from 'vant'
import { findDev } from '@/api/revive'
export default {
    name: 'ReviveTable',
    components: {
        Icon,
        Search
    },
    props: {
        currYear: {
            type: Number,
            default: 0
        },
        selectMonth: {
            type: Array,
            default: () => { return [] }
        },
        currBus: {
            type: String,
            default: ''
        },
        currCity: {
            type: String,
            default: ''
        },
        time: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            active: '', // isObtains我司获取 isFocus重点跟进 isRegret遗憾项目
            keyword: '',
            searchState: false,
            orderByColumn: 'evalType',
            orderByType: 'ASC',
            list: [],
            isObtains: false, // 我司获取
            isFocus: false, // 重点跟进
            isRegret: false // 遗憾项目
        }
    },
    watch: {
        time(n) {
            this.findDev()
        }
    },
    created() {
        this.findDev()
    },
    methods: {
        goDetail(item) {
            this.$router.push(
                {path: '/report',
                    query: {
                        landId: item.landId,
                        plateId: item.plateId,
                        versionId: item.versionId
                    }
                }
            )
        },
        confirmSearch() {
            this.findDev()
        },
        switchActive(type) {
            console.log(type)
            this[type] = !this[type]
            if (type === 'isObtains') {
                if (this[type]) {
                    this[type] = true
                    this.isFocus = false
                    this.isRegret = false
                }
            } else {
                this.isObtains = false
            }
            this.findDev()
        },
        showRow(item) {
            console.log(654321)
            item.show = !item.show
        },
        sort(type) {
            if (type === this.orderByColumn) {
                this.orderByType = this.orderByType === 'DESC' ? 'ASC' : 'DESC'
            } else {
                this.orderByType = 'DESC'
            }
            this.orderByColumn = type

            this.findDev()
        },
        async findDev() {
            const parmas = {
                openingTimeYear: this.currYear == '0' ? '' : this.currYear,
                openingTimeMonths: this.selectMonth,
                deptId: this.currBus,
                cityCompId: this.currCity,
                orderByColumn: this.orderByColumn,
                orderByType: this.orderByType
            }
            // 支持分别选择【我司获取】【重点跟进】【遗憾项目】这3个标签进行查询
            // 支持同时选择【重点跟进】【遗憾项目】这2个标签进行查询

            if (this.isObtains) {
                parmas['isObtains'] = 1
            }

            if (this.isFocus && this.isRegret) {
                parmas['isRegretOrFocus'] = 1
            } else {
                const arr = ['isFocus', 'isRegret']
                arr.forEach(item => {
                    if (this[item]) {
                        parmas[item] = 1
                    }
                })
            }

            if (this.keyword) {
                parmas.landNameLike = this.keyword
            }
            await findDev(parmas).then(res => {
                res.forEach(item => {
                    item.show = false
                })
                this.$set(this, 'list', res)
                // this.list = res
            })
            Toast.clear()
        }
    }
}
</script>

<style lang="scss" scoped>
  .revive-table {
        .my-button {
          box-sizing: border-box;
          height:.6rem /* 60/100 */;
          border:1px solid rgba(151,151,151,1);
          text-align: center;
          display:inline-block;
          color:rgba(151,151,151,1);
          margin-right:.2rem /* 20/100 */;
          line-height: .6rem /* 60/100 */;
          padding:0 .2rem /* 20/100 */;
      }

      .my-button.active {
        border-color: #2761FF;
        color:#2761FF;
      }

      .my-button.round {
        width:.6rem /* 60/100 */;
        height:.6rem /* 60/100 */;
        border-radius: 50%;
        border-color:white;
        color:rgba(38,38,38,1);
        background: white;
        text-align:center;
        padding:0;
        font-size:.2rem /* 20/100 */;
        line-height:.7rem /* 60/100 */;
      }

      .search-bar {
          display:flex;
          box-sizing: border-box;
          justify-content: space-between;
          height:1rem /* 100/100 */;
          background:rgba(248,248,248,1);
          padding:.2rem /* 20/100 */;

          .right {
            .divide {
              font-size:.4rem;
              color: rgba(214,214,214,1);
              margin-right:.2rem /* 20/100 */;
            }
          }
      }

      .my-table {
          border-spacing:0;
          width:100%;
          table-layout:fixed;
          thead {
              tr{
                height:.7rem /* 70/100 */;
                background: #2761FF;
                color:white;
                font-size:.24rem /* 24/100 */;
                box-shadow:0px 4 10px 0px rgba(0,0,0,0.2);
                text-align: left;
                width:100%;
                th {
                  padding:.1rem /* 10/100 */;
                }
              }
          }
          tbody {
              tr{
                width:100%;
                height:.7rem /* 70/100 */;
                color:black;
                font-size:.28rem /* 28/100 */;
                td {
                  padding:.1rem /* 10/100 */;
                  border-bottom: .01rem /* 1/100 */ solid rgba(221,221,221,1);
                }
                td.name {
                  white-space:pre-wrap !important;
                }

                td.show {
                  white-space:pre-wrap !important;
                }
              }
          }
          .sort {
            position: relative;
          }

          .sort:before {
            content:'';
            display:inline-block;
            width: 0;
            height: 0;
            border-width: .1rem /* 10/100 */;
            border-style: solid;
            border-color:rgba(255,255,255,.5) transparent transparent transparent;
            position: absolute;
            bottom:-.07rem /* 10/100 */;
            left:.05rem /* 5/100 */;
          }

          .sort:after {
            content:'';
            display:inline-block;
            width: 0;
            height: 0;
            border-width: .1rem /* 10/100 */;
            border-style: solid;
            border-color:rgba(255,255,255,.5) transparent transparent transparent;
            transform: rotate(180deg);
            position: absolute;
            top:-.07rem /* 10/100 */;
            left:.05rem /* 5/100 */;

          }

          .sort-down {
            position: relative;
          }

          .sort-down:before {
            content:'';
            display:inline-block;
            width: 0;
            height: 0;
            border-width: .1rem /* 10/100 */;
            border-style: solid;
            border-color:rgba(255,255,255,1) transparent transparent transparent;
            position: absolute;
            bottom:-.07rem /* 10/100 */;
            left:.05rem /* 5/100 */;
          }

          .sort-up {
            position: relative;
          }

          .sort-up:after {
            content:'';
            display:inline-block;
            width: 0;
            height: 0;
            border-width: .1rem /* 10/100 */;
            border-style: solid;
            border-color:rgba(255,255,255,1) transparent transparent transparent;
            transform: rotate(180deg);
            position: absolute;
            top:-.07rem /* 10/100 */;
            left:.05rem /* 5/100 */;

          }
      }
  }
</style>

<style lang="scss">
    .revive-table {
        .my-button.round {
            .van-icon {
                    font: .3rem /* 20/100 */ "vant-icon";
            }
        }

        .van-search__content {
          // height:.6rem /* 60/100 */;
          border-radius: .3rem /* 30/100 */;
        }
    }
</style>
